import React from 'react';
import styled from 'styled-components';

const CompanyInitials = styled.div.attrs(() => ({ className: 'client-avatar-company-initials' }))`
  background: ${({ theme }) => theme.colors.disabled};
  color: ${({ theme }) => theme.colors.primary};
  width: 24px;
  height: 24px;
  min-width: 24px;
  min-height: 24px;
  border-radius: 100%;
  align-items: center;
  justify-content: center;
  display: flex;
  font-weight: 500;
  border: 1px solid ${({ theme }) => theme.colors.grey2};
`;

const Logo = styled.img.attrs(() => ({ className: 'client-avatar-logo' }))`
  width: 24px;
  height: 24px;
  max-width: 24px;
  max-height: 24px;
  border-radius: 100%;
  border: 1px solid ${({ theme }) => theme.colors.grey2};
`;

const ClientAvatar = ({ name, logo, dataTestId }) => {
  if (logo) {
    return <Logo src={logo} data-testid={dataTestId} />;
  }

  if (name) {
    return <CompanyInitials data-testid={dataTestId}>{name[0]}</CompanyInitials>;
  }

  return <></>;
};

export default ClientAvatar;
